import React from 'react';
import { Box } from '@mui/material';
import { useShowContext } from 'framework/show';
import { CreateButton, LinkButton } from 'framework/ui/ui-builder';
import useLeaveService from 'domain/people/leave/shared/leaveService';
import { useOneStopRequestsUrl } from 'domain/shared/oneStop';
import useLeavePolicyUrl from '../shared/hooks/useLeavePolicyUrl';
import UpcomingLeavesLayout from './List/UpcomingLeavesLayout';
import { ShowPortalLeaveType } from '../Show/type';
import { ListWithInfiniteScroll } from 'framework/list';

interface LoadingParams {
  pageNumber?: number;
  pageSize?: number;
}

const UpcomingLeaves = () => {
  const { searchUpcomingLeaves } = useLeaveService();
  const {
    data: { userId: employeeId },
  } = useShowContext<ShowPortalLeaveType>();
  const { getSingleEntityUrl: getSingleOneStopEntityUrl } = useOneStopRequestsUrl();
  const { leavePolicyUrl } = useLeavePolicyUrl(employeeId);

  const getDataMethod = async (params: LoadingParams) => {
    return searchUpcomingLeaves(employeeId, {
      pageNumber: params.pageNumber || 0,
      pageSize: params.pageSize || 5,
    });
  };

  return (
    <Box>
      <ListWithInfiniteScroll getDataMethod={getDataMethod} pageSize={5} disableUrlUpdate>
        <UpcomingLeavesLayout />
      </ListWithInfiniteScroll>

      <Box sx={{ mt: 2, display: 'flex', gap: 4 }}>
        <CreateButton
          variant="contained"
          sx={{ textTransform: 'none' }}
          url={getSingleOneStopEntityUrl('HR03')}
          label="Request leave"
          size="small"
        />
        {leavePolicyUrl && (
          <LinkButton
            variant="outlined"
            size="small"
            url={leavePolicyUrl}
            sx={{
              textTransform: 'none',
              border: 'none',
              '&:hover': {
                textDecoration: 'underline',
                border: 'none',
                backgroundColor: 'transparent',
              },
            }}
          >
            Read leave policy
          </LinkButton>
        )}
      </Box>
    </Box>
  );
};

export default UpcomingLeaves;
